import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class RestartTaskActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (record.specifics.isNsva) {
      return true;
    }

    if (ProtectedEntitiesHelper.isAwsInstance(record) && ProtectedEntitiesHelper.isPowerStateTerminated(record)) {
      return false;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return !!record.specifics.isSva;
    }

    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (ProtectedEntitiesHelper.isUnifiedClient(record)) {
      return true;
    }

    if (ProtectedEntitiesHelper.isEpClient(record)) {
      return true;
    }

    if (ProtectedEntitiesHelper.isMacClient(record)) {
      return true;
    }

    if (record.specifics.isSva && record.specifics.ip !== Application.Main.user.companyInfo.aioSvaIp) {
      return true;
    }

    return false;
  }
}
